<template>
  <component :is="themeComponent" v-if="themeComponent"></component>
</template>

<script>
import { markRaw } from 'vue'

export default {
  name: "navi-desktop",
  components: {
  },
  props: {
    theme: {
      type: String,
      default: 'hermeneus-base'
    }
  },
  data() {
    return {
      themeComponent: null,
      activeSubNavi: null,
    }
  },
  watch: {
    theme: {
      immediate: true,
      async handler(newTheme) {
        const themePath = newTheme
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join('')
        try {
          const module = await import(`@modules/Themes/${themePath}/resources/vue/navi/NaviDesktop${themePath}.vue`)
          this.themeComponent = markRaw(module.default)
        } catch (error) {
          console.error(`Failed to load theme component: ${error}`)
        }
      }
    }
  },
  methods: {
    /**
     * Ist für den aktuell eingeloggten Nutzer überhaupt ein Menüpunkt der Subnavi sichtbar oder sieht er gar nichts?
     * @param category
     */
    hasVisibleSubnavi (category) {
      return category.filter(subcategory => {
        return (subcategory.hasOwnProperty('show') && subcategory.show === true) || !subcategory.hasOwnProperty('show');
      }).length > 0;
    }
  },
  mounted () {
    window.addEventListener("scroll", function (e) {
      if (window.scrollY >= 300) {
        document.querySelector('.navi-desktop').classList.add('is-floating');

      } else {

        document.querySelector('.navi-desktop').classList.remove('is-floating');
      }
    });
  }
}
</script>

<style scoped>

</style>